export const GRAFANA_DATASOURCE_REF = {
  name: 'grafana',
  uid: 'grafana',
};
